export default __webpack_public_path__ + "static/fullstack-0a806a897755237dd87d0efff3a51a12.svg";